// extracted by mini-css-extract-plugin
module.exports = {"suspended":"_f4be18c","inputWrapper":"_4912e41"};